import {
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  FETCH_PRODUCT_BY_ID_REQUEST,
  FETCH_PRODUCT_BY_ID_SUCCESS,
  FETCH_PRODUCT_BY_ID_FAILURE,
  FETCH_PRODUCTS_BY_CATEGORY_REQUEST,
  FETCH_PRODUCTS_BY_CATEGORY_SUCCESS,
  FETCH_PRODUCTS_BY_CATEGORY_FAILURE,
  FETCH_ALL_PRODUCTS_REQUEST,
  FETCH_ALL_PRODUCTS_SUCCESS,
  FETCH_ALL_PRODUCTS_FAILURE,
} from "../actions/ProductActions.js";

const initialState = {
  loading: false,
  products: [],
  allProducts: [],
  selectedProduct: null,
  next: null,
  previous: null,
  count: 0,
  error: "",
  productsByCategory: [],
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch all products cases
    case FETCH_ALL_PRODUCTS_REQUEST:
      return { ...state, loading: true, error: "" };
    case FETCH_ALL_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        allProducts: action.payload.results,
      };
    case FETCH_ALL_PRODUCTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Fetch products cases
    case FETCH_PRODUCTS_REQUEST:
      return { ...state, loading: true, error: "" };
    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload.results,
        next: action.payload.next,
        previous: action.payload.previous,
        count: action.payload.count,
      };
    case FETCH_PRODUCTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Fetch product by ID cases
    case FETCH_PRODUCT_BY_ID_REQUEST:
      return { ...state, loading: true, error: "" };
    case FETCH_PRODUCT_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedProduct: {
          ...action.payload.product,
          related_products: action.payload.related_products,
        },
      };
    case FETCH_PRODUCT_BY_ID_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Fetch products by category cases
    case FETCH_PRODUCTS_BY_CATEGORY_REQUEST:
      return { ...state, loading: true, error: "" };
    case FETCH_PRODUCTS_BY_CATEGORY_SUCCESS:
      return { ...state, loading: false, products: action.payload };
    case FETCH_PRODUCTS_BY_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default productReducer;
